import { Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Admin pages

// Import PrivateRoute
import PrivateRoute from "./components/PrivateRoute";

// Admin pages (lazy loading)
const Dashboard = lazy(() => import("./pages/admin/Dashboard"));
const BannerAdd = lazy(() => import("./pages/admin/BannerAdd"));
const BannerList = lazy(() => import("./pages/admin/BannerList"));
const CategoryAdd = lazy(() => import("./pages/admin/CategoryAdd"));
const CategoryList = lazy(() => import("./pages/admin/CategoryList"));
const BannerEdit = lazy(() => import("./pages/admin/BannerEdit"));
const CategoryEdit = lazy(() => import("./pages/admin/CategoryEdit"));
const ColourAdd = lazy(() => import("./pages/admin/ColourAdd"));
const ColourList = lazy(() => import("./pages/admin/ColourList"));
const ColourEdit = lazy(() => import("./pages/admin/ColourEdit"));
const SubCategoryAdd = lazy(() => import("./pages/admin/SubCategoryAdd"));
const MainCategoryList = lazy(() => import("./pages/admin/MainCategoryList"));
const SubCategoryList = lazy(() => import("./pages/admin/SubCategoryList"));
const SubCategoryEdit = lazy(() => import("./pages/admin/SubCategoryEdit"));
const SizeAdd = lazy(() => import("./pages/admin/SizeAdd"));
const SizeList = lazy(() => import("./pages/admin/SizeList"));
const SizeEdit = lazy(() => import("./pages/admin/SizeEdit"));
const ContactList = lazy(() => import("./pages/admin/ContactList"));
const OrderList = lazy(() => import("./pages/admin/OrderList"));
const CustomerList = lazy(() => import("./pages/admin/CustomerList"));
const ProductAdd = lazy(() => import("./pages/admin/ProductAdd"));
const OfferAdd = lazy(() => import("./pages/admin/offerAdd"));
const ProductList = lazy(() => import("./pages/admin/ProductList"));
const OfferList = lazy(() => import("./pages/admin/OfferList"));
const OfferEdit = lazy(() => import("./pages/admin/OfferEdit"));
const ProductEdit = lazy(() => import("./pages/admin/ProductEdit"));
const AddShipping = lazy(() => import("./pages/admin/AddShipping"));
const ShippingList = lazy(() => import("./pages/admin/ShippingList"));
const ShippingEdit = lazy(() => import("./pages/admin/ShippingEdit"));
const ReviewList = lazy(() => import("./pages/admin/ReviewList"));


// home pages
const HomeFashion = lazy(() => import("./pages/home/HomeFashion"));

// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"));
const ShopGridFilter = lazy(() => import("./pages/shop/ShopGridFilter"));

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));



// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));
const HomeBookStore = lazy(() => import("./pages/home/HomeBookStore"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
// const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));

const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = () => {
  return (
    <Router>
      <ScrollToTop>
        <Suspense
          fallback={
            <div className="flone-preloader-wrapper">
              <div className="flone-preloader">
                <span></span>
                <span></span>
              </div>
            </div>
          }
        >
          <Routes>
            <Route
              path={process.env.PUBLIC_URL + "/"}
              element={<HomeFashion />}
            />

            {/* Homepages */}
            <Route
              path={process.env.PUBLIC_URL + "/home-fashion"}
              element={<HomeFashion />}
            />
          
            {/* Shop pages */}
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-standard"}
              element={<ShopGridStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-filter"}
              element={<ShopGridFilter />}
            />
           
            {/* Shop product pages */}
            <Route
              path={process.env.PUBLIC_URL + "/product/:id"}
              element={<Product />}
            />
            <Route
                path={process.env.PUBLIC_URL + "/home-book-store"}
                element={<HomeBookStore/>}
              />

            {/* ==================== PROTECTED ADMIN ROUTES ==================== */}
            <Route element={<PrivateRoute />}>
              {/* Admin Dashboard */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/dashboard"}
                element={<Dashboard />}
              />

              {/* Banner Routes */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/BannerAdd"}
                element={<BannerAdd />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/BannerList"}
                element={<BannerList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/BannerEdit/:id"}
                element={<BannerEdit />}
              />

              {/* Category Routes */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/CategoryAdd"}
                element={<CategoryAdd />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/CategoryList"}
                element={<CategoryList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/CategoryEdit/:id"}
                element={<CategoryEdit />}
              />

              {/* SubCategory Routes */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/SubCategoryAdd"}
                element={<SubCategoryAdd />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/SubCategoryList/:id"}
                element={<SubCategoryList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/SubCategoryEdit/:id"}
                element={<SubCategoryEdit />}
              />

              {/* Main Category List */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/MainCategoryList"}
                element={<MainCategoryList />}
              />

              {/* Colour Routes */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/ColourAdd"}
                element={<ColourAdd />}
              />
              {/* AddShipping Routes */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/AddShipping"}
                element={<AddShipping />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/ColourList"}
                element={<ColourList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/ColourEdit/:id"}
                element={<ColourEdit />}
              />

              {/* Size Routes */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/SizeAdd"}
                element={<SizeAdd />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/SizeList"}
                element={<SizeList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/SizeEdit/:id"}
                element={<SizeEdit />}
              />

              {/* Product Routes */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/ProductAdd"}
                element={<ProductAdd />}
              />
              {/* Offer Routes */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/offerAdd"}
                element={<OfferAdd />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/ProductList"}
                element={<ProductList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/ShippingList"}
                element={<ShippingList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/OfferList"}
                element={<OfferList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/OfferEdit/:id"}
                element={<OfferEdit />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/ShippingEdit/:id"}
                element={<ShippingEdit />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/ProductEdit/:id"}
                element={<ProductEdit />}
              />

              {/* Order, Contact & Customer */}
              <Route
                path={process.env.PUBLIC_URL + "/admin/OrderList"}
                element={<OrderList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/ContactList"}
                element={<ContactList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/CustomerList"}
                element={<CustomerList />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin/ReviewList"}
                element={<ReviewList />}
              />
            </Route>

            {/* Fallback - Redirect unknown routes to home */}
            <Route
              path="*"
              element={<Navigate to={process.env.PUBLIC_URL + "/"} replace />}
            />

            {/* Other pages */}
            <Route
              path={process.env.PUBLIC_URL + "/about"}
              element={<About />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contact"}
              element={<Contact />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/my-account"}
              element={<MyAccount />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/login-register"}
              element={<LoginRegister />}
            />

            <Route path={process.env.PUBLIC_URL + "/cart"} element={<Cart />} />
            <Route
              path={process.env.PUBLIC_URL + "/wishlist"}
              element={<Wishlist />}
            />
            {/* <Route
              path={process.env.PUBLIC_URL + "/compare"}
              element={<Compare />}
            /> */}
            <Route
              path={process.env.PUBLIC_URL + "/checkout"}
              element={<Checkout />}
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
